import { render, staticRenderFns } from "./unitsDetailPerson.vue?vue&type=template&id=41bbb8fe&"
import script from "./unitsDetailPerson.vue?vue&type=script&lang=js&"
export * from "./unitsDetailPerson.vue?vue&type=script&lang=js&"
import style0 from "./unitsDetailPerson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports